import createIcon from '../../createIcon';

/**
 * @component @name Blind
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAuNzUgNS4yNUMxMS44NTQ2IDUuMjUgMTIuNzUgNC4zNTQ1NyAxMi43NSAzLjI1QzEyLjc1IDIuMTQ1NDMgMTEuODU0NiAxLjI1IDEwLjc1IDEuMjVDOS42NDU0MyAxLjI1IDguNzUgMi4xNDU0MyA4Ljc1IDMuMjVDOC43NSA0LjM1NDU3IDkuNjQ1NDMgNS4yNSAxMC43NSA1LjI1WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTExLjM4IDYuODdDMTEuMjEgNi41MiAxMC45NCA2LjIyIDEwLjU4IDYuMDJDOS45NyA1LjY2IDkuMjQgNS42OCA4LjY1IDUuOTlWNS45OEwzLjI1IDkuMDVWMTMuNzVINS4yNVYxMC4yMUw2Ljc1IDkuMzZDNi40MyAxMC40NiA2LjI1IDExLjYgNi4yNSAxMi43NVYxOC4wOEwzLjY1IDIxLjU1TDUuMjUgMjIuNzVMOC4yNSAxOC43NUw4LjQ3IDE1LjIxTDEwLjI1IDE3Ljc1VjIyLjc1SDEyLjI1VjE2LjI1TDEwLjI4IDEzLjQ0QzEwLjI0IDEyLjkyIDEwLjE0IDExLjY4IDEwLjczIDEwLjA0QzExLjQ4IDExLjE4IDEyLjYxIDEyLjAyIDEzLjkzIDEyLjQ1TDE5Ljg4IDIyLjc1TDIwLjc1IDIyLjI1TDE1LjI3IDEyLjc1SDE2LjI1VjEwLjc1QzE1Ljc2IDEwLjc1IDEzLjM3IDEwLjkyIDEyLjE3IDguNTQiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Blind = createIcon('Blind', [
  [
    'path',
    {
      d: 'M10.75 5.25C11.8546 5.25 12.75 4.35457 12.75 3.25C12.75 2.14543 11.8546 1.25 10.75 1.25C9.64543 1.25 8.75 2.14543 8.75 3.25C8.75 4.35457 9.64543 5.25 10.75 5.25Z',
      key: '9nweal',
    },
  ],
  [
    'path',
    {
      d: 'M11.38 6.87C11.21 6.52 10.94 6.22 10.58 6.02C9.97 5.66 9.24 5.68 8.65 5.99V5.98L3.25 9.05V13.75H5.25V10.21L6.75 9.36C6.43 10.46 6.25 11.6 6.25 12.75V18.08L3.65 21.55L5.25 22.75L8.25 18.75L8.47 15.21L10.25 17.75V22.75H12.25V16.25L10.28 13.44C10.24 12.92 10.14 11.68 10.73 10.04C11.48 11.18 12.61 12.02 13.93 12.45L19.88 22.75L20.75 22.25L15.27 12.75H16.25V10.75C15.76 10.75 13.37 10.92 12.17 8.54',
      key: '1oo30b',
    },
  ],
]);

export default Blind;
